var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.41669 6.91666H6.91669V6.41666V4.58332H7.08335V6.41666V6.91666H7.58335H9.41669V7.08332H7.58335H7.08335V7.58332V9.41666H6.91669V7.58332V7.08332H6.41669H4.58335V6.91666H6.41669ZM1.66669 6.99999C1.66669 4.06197 4.062 1.66666 7.00002 1.66666C9.93804 1.66666 12.3334 4.06197 12.3334 6.99999C12.3334 9.93801 9.93804 12.3333 7.00002 12.3333C4.062 12.3333 1.66669 9.93801 1.66669 6.99999ZM1.83335 6.99999C1.83335 9.84863 4.15138 12.1667 7.00002 12.1667C9.84866 12.1667 12.1667 9.84863 12.1667 6.99999C12.1667 4.15135 9.84866 1.83332 7.00002 1.83332C4.15138 1.83332 1.83335 4.15135 1.83335 6.99999Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/addButton.f40607de390289535d085643faeb8086.svg";
export { ForwardRef as ReactComponent };